import React, { createContext } from 'react';
const FarmsContextData = createContext(null);
export { FarmsContextData };
